import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
/**
 * Chart styling model definition
 */
export class ChartStylingModel extends CoreStylingModel {
/**
 * It is css value for chart bars container width. Default: '100%'.
 */
barsContainerWidth: string;
/**
 * It is css value for chart bars container height. Default: '200px.
 */
barsContainerHeight: string;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function ChartStylingModel_tsickle_Closure_declarations() {
/**
 * It is css value for chart bars container width. Default: '100%'.
 * @type {?}
 */
ChartStylingModel.prototype.barsContainerWidth;
/**
 * It is css value for chart bars container height. Default: '200px.
 * @type {?}
 */
ChartStylingModel.prototype.barsContainerHeight;
}

